module.exports = __webpack_public_path__ + "static/media/c3.e8a6b6ba.jpg";